import { type DefaultValues, type FieldValues } from 'react-hook-form';

import { isFieldValueEmpty } from './isFieldValueEmpty';

export const arePersistedValuesDifferent = <TFieldValues extends FieldValues>(
  persistedValues: Partial<TFieldValues> | undefined,
  defaultValues: DefaultValues<TFieldValues> | undefined,
): boolean => {
  if (!persistedValues) {
    return false;
  }

  const hasDifference = Object.keys(persistedValues).reduce(
    (hasDifference, key) => {
      if (hasDifference) {
        return true;
      }

      const persistedValue = persistedValues[key];
      const defaultValue = defaultValues?.[key];

      if (
        isFieldValueEmpty(persistedValue) &&
        isFieldValueEmpty(defaultValue)
      ) {
        return false;
      }

      if (persistedValue === defaultValue) {
        return false;
      }

      return true;
    },
    false,
  );

  return hasDifference;
};
